<app-lecture-add-button [course]="course">
  <button mat-menu-item>새로운 강의 추가</button>
</app-lecture-add-button>
<app-lecture-import-button [course]="course">
  <button mat-menu-item>강의 가져오기</button>
</app-lecture-import-button>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-add-button-menu/lecture-add-button-menu.component.html